import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import _ from "lodash";


import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import * as modalActions from "../../_shared/modal/modalActions";

const mapDispatchToProps = dispatch => ({
  onOK: () => {
    dispatch(modalActions.closeModal());
  },
});

export const LinkedDocumentStatusModalContent = ({ onOK }) => {
  return (
    <Fragment>
      <DialogTitle id='responsive-dialog-title'>Cannot Change Status</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This document is already linked to another project. The status cannot be changed from &apos;Public Viewable&apos; to &apos;In Progress&apos;.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={onOK} color='primary'>
          OK
        </Button>
      </DialogActions>
    </Fragment>
  );
};

LinkedDocumentStatusModalContent.defaultProps = {
  onOK: _.noop,
};

LinkedDocumentStatusModalContent.propTypes = {
  onOK: PropTypes.func,
};

const reduxConnected = connect(
  null,
  mapDispatchToProps,
)(LinkedDocumentStatusModalContent);

export default withRouter(reduxConnected);
